<template>
  <div class="container-fluid">
    <!-- Header con información del tarifario -->
    <div class="row mb-4">
      <div class="col-12">
        <div class="col-md-12 text-right mt-2">
          <div class="btn-group">
            <button
              type="button"
              class="btn bg-navy btn-sm"
              data-toggle="modal"
              data-target="#modalNuevaTarifa"
              @click="$refs.tarifarioAsignarTarifa.limpiarFormulario()"
              v-if="
                $store.getters.can('hidrocarburos.tarifarios.tarifaCreate')
              "
            >
              <i class="fas fa-plus mr-1"></i>
              Nueva Tarifa
            </button>
            <!-- <button
              type="button"
              class="btn btn-success btn-sm"
              data-toggle="modal"
              data-target="#modalImportarMasivo"
              @click="getFormFormato()"
              v-if="$store.getters.can('hidrocarburos.tarifas.create')"
            >
              <i class="fas fa-file-excel mr-1"></i>
              Importar
            </button> -->
          </div>
        </div>
      </div>
    </div>

    <!-- Tabla de tarifas existentes -->
    <div class="row">
      <div class="col-12 p-0">
        <div class="card-header bg-white border-bottom">
          <div class="row align-items-center">
            <!-- Boton de filtros -->
            <div class="col-md-6">
              <h5 class="mb-0">
                <button
                  type="button"
                  class="btn btn-md"
                  :class="
                    ver_filtros
                      ? 'border border-olive bg-olive'
                      : 'border border-default bg-light'
                  "
                  @click="ver_filtros = !ver_filtros"
                >
                  <i class="fas fa-list mr-2"></i>
                  Filtros
                </button>
              </h5>
            </div>
            <!-- Buscador -->
            <div class="col-md-6">
              <div class="input-group input-group-sm">
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <i class="fas fa-search"></i>
                  </span>
                </div>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Buscar tarifas..."
                  v-model="filtroBusqueda"
                  @input="filtrarTarifas"
                />
              </div>
            </div>
          </div>
          <!-- Filtros -->
          <div class="row justify-content-center mt-4" v-if="ver_filtros">
            <div class="col-md-4">
              <div class="form-group">
                <label>Tipo Vehículo</label>
                <div class="input-group input-group-sm">
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <i class="fas fa-car-side"></i>
                    </span>
                  </div>
                  <v-select
                    v-model="tipo_vehiculo_filter"
                    placeholder="Tipo de vehículo"
                    label="nombre"
                    :class="[
                      $store.getters.getDarkMode ? 'dark-vselect' : '',
                      'form-control p-0',
                    ]"
                    :options="listasForms.tipos_vehiculos"
                    @input="selectTipoVehiculoFilter()"
                  >
                  </v-select>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Categoría</label>
                <div class="input-group input-group-sm">
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <i class="fas fa-cogs"></i>
                    </span>
                  </div>
                  <v-select
                    :class="[
                      $store.getters.getDarkMode ? 'dark-vselect' : '',
                      'form-control p-0',
                    ]"
                    v-model="categoria_filter"
                    placeholder="Categoría"
                    label="descripcion"
                    :options="listasForms.categorias"
                    @input="selectCategoriaFilter()"
                  >
                  </v-select>
                </div>
              </div>
            </div>
            <div class="col-md-5">
              <div class="form-group">
                <label>Producto Líquido</label>
                <div class="input-group input-group-sm">
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <i class="fas fa-tint"></i>
                    </span>
                  </div>
                  <v-select
                    :class="[
                      $store.getters.getDarkMode ? 'dark-vselect' : '',
                      'form-control p-0',
                    ]"
                    v-model="producto_liquido_filter"
                    placeholder="Producto Líquido"
                    label="nombre"
                    :options="listasForms.productos"
                    @input="selectProductoLiquidoFilter()"
                  >
                  </v-select>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Bloque</label>
                <div class="input-group input-group-sm">
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <i class="fas fa-map-marker-alt"></i>
                    </span>
                  </div>
                  <v-select
                    :class="[
                      $store.getters.getDarkMode ? 'dark-vselect' : '',
                      'form-control p-0',
                    ]"
                    v-model="bloque_filter"
                    placeholder="Bloque"
                    label="nombre"
                    :options="listasForms.bloques"
                    @input="selectBloqueFilter()"
                  >
                  </v-select>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Sitio Destino</label>
                <div class="input-group input-group-sm">
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <i class="fas fa-map-marked-alt"></i>
                    </span>
                  </div>
                  <v-select
                    :class="[
                      $store.getters.getDarkMode ? 'dark-vselect' : '',
                      'form-control p-0',
                    ]"
                    v-model="sitio_destino_filter"
                    placeholder="Sitio Destino"
                    label="nombre"
                    :options="listasForms.sitios_destino"
                    @input="selectSitioDestinoFilter()"
                  >
                  </v-select>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Tabla de tarifas -->
        <div class="card-body p-0">
          <div class="card-footer border border-default bg-light">
            <div class="row align-items-center">
              <div class="col-md-6">
                <b class="text-muted m-0">
                  Mostrando: <strong>{{ tarifasFiltradas.length }}</strong> de
                  <strong>{{ tarifas.length }}</strong> tarifas
                </b>
                <b class="text-muted m-0 float-right">
                  <strong>Empresa: </strong>
                  <span class="badge badge-primary">{{
                    $parent.empresa?.razon_social
                  }}</span>
                </b>
              </div>
              <div class="col-md-6 text-right">
                <button
                  type="button"
                  class="btn btn-outline-primary btn-sm"
                  @click="cargarTarifas"
                  :disabled="tarifasCargando"
                >
                  <i
                    class="fas fa-sync-alt mr-1 fa-spin"
                    :class="{ 'fa-spin': tarifasCargando }"
                  ></i>
                  Actualizar
                </button>
              </div>
            </div>
          </div>
          <!-- Tabla de tarifas -->
          <table
            class="table table-hover table-bordered table-striped table-sm text-nowrap table-responsive"
          >
            <thead class="bg-dark">
              <tr class="text-center">
                <th>
                  <i class="fas fa-hashtag mr-1"></i>
                  ID
                </th>
                <th>
                  <i class="fas fa-tag mr-1"></i>
                  Nombre
                </th>
                <th>
                  <i class="fas fa-truck mr-1"></i>
                  Tipo Vehículo
                </th>
                <th>
                  <i class="fas fa-blocks mr-1"></i>
                  Bloque
                </th>
                <th>
                  <i class="fas fa-map-marked-alt mr-1"></i>
                  Sitio Destino
                </th>
                <th>
                  <i class="fas fa-tachometer-alt mr-1"></i>
                  KM
                </th>
                <th>
                  <i class="fas fa-cogs mr-1"></i>
                  Categoría
                </th>
                <th>
                  <i class="fas fa-play mr-1"></i>
                  Tipo Op.
                </th>
                <th>
                  <i class="fas fa-tint mr-1"></i>
                  Producto
                </th>
                <th>
                  <i class="fas fa-cog mr-1"></i>
                  Acciones
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="tarifasCargando">
                <td colspan="10" class="text-center py-4">
                  <div class="spinner-border text-primary" role="status">
                    <span class="sr-only">Cargando...</span>
                  </div>
                  <p class="mt-2 text-muted">Cargando tarifas...</p>
                </td>
              </tr>
              <tr v-else-if="tarifasFiltradas.length === 0">
                <td colspan="10" class="text-center py-4">
                  <i class="fas fa-inbox fa-3x text-muted mb-3"></i>
                  <p class="text-muted">
                    No hay tarifas registradas para este tarifario
                  </p>
                  <button
                    type="button"
                    class="btn btn-primary btn-sm"
                    data-toggle="modal"
                    data-target="#modalNuevaTarifa"
                    @click="$refs.tarifarioAsignarTarifa.limpiarFormulario()"
                    v-if="$store.getters.can('hidrocarburos.tarifarios.tarifaCreate')"
                  >
                    <i class="fas fa-plus mr-1"></i>
                    Crear Primera Tarifa
                  </button>
                </td>
              </tr>
              <tr
                v-for="tarifa in tarifasFiltradas"
                :key="tarifa.id"
                class="tarifa-row text-center"
              >
                <td>
                  {{ tarifa.id }}
                </td>
                <td>
                  {{ tarifa.nombre || "Sin nombre" }}
                </td>
                <td>
                  <span class="text-muted">{{
                    tarifa.tipo_vehiculo?.nombre || "N/A"
                  }}</span>
                </td>
                <td>
                  <span class="text-muted">{{
                    tarifa.bloque?.nombre || "N/A"
                  }}</span>
                </td>
                <td>
                  <span class="text-muted">{{
                    tarifa.sitio_destino?.nombre || "N/A"
                  }}</span>
                </td>
                <td class="text-center">
                  <span class="badge badge-info">{{ tarifa.km || "N/A" }}</span>
                </td>
                <td class="text-center">
                  <span class="badge badge-secondary">{{
                    tarifa.nCategoria || "N/A"
                  }}</span>
                </td>
                <td class="text-center">
                  <span class="badge badge-info">{{
                    tarifa.nTipoOperacion || "N/A"
                  }}</span>
                </td>
                <td class="text-center">
                  <span class="text-muted small">{{
                    tarifa.producto_liquido?.nombre || "N/A"
                  }}</span>
                </td>
                <td class="text-center">
                  <div class="btn-group btn-group-sm">
                    <button
                      type="button"
                      class="btn btn-outline-primary"
                      data-toggle="modal"
                      data-target="#modalNuevaTarifa"
                      @click="editarTarifa(tarifa)"
                      v-if="$store.getters.can('hidrocarburos.tarifarios.tarifaEdit')"
                      title="Editar tarifa"
                    >
                      <i class="fas fa-edit"></i>
                    </button>
                    <button
                      type="button"
                      class="btn btn-outline-info"
                      data-toggle="modal"
                      data-target="#modalDetallesTarifa"
                      @click="verDetallesTarifa(tarifa.id)"
                      v-if="$store.getters.can('hidrocarburos.tarifarios.tarifaDetalleShow')"
                      title="Ver detalles"
                    >
                      <i class="fas fa-eye"></i>
                    </button>
                    <!-- <button
                      type="button"
                      class="btn btn-outline-danger"
                      @click="eliminarTarifa(tarifa)"
                      v-if="$store.getters.can('hidrocarburos.tarifas.delete')"
                      title="Eliminar tarifa"
                    >
                      <i class="fas fa-trash"></i>
                    </button> -->
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <TarifarioAsignarTarifa ref="tarifarioAsignarTarifa" />
    <!-- Modal para ver detalles de tarifa -->
    <div
      class="modal fade"
      id="modalDetallesTarifa"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header bg-geogo-top-left text-white pt-2 pb-2">
            <h5 class="modal-title">
              <i class="fas fa-history mr-2"></i> Histórico de tarifas
            </h5>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              ref="closeModalDetalleTarifa"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <TarifaDetalleTarifario ref="tarifaDetalleTarifario" />
          </div>
          <div class="modal-footer pt-2 pb-2">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              <i class="fas fa-times mr-1"></i>
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import vSelect from "vue-select";
import TarifaDetalleTarifario from "./TarifaDetalleTarifario";
import TarifarioAsignarTarifa from "./TarifarioAsignarTarifa";

export default {
  name: "TarifasTarifario",
  components: {
    vSelect,
    TarifarioAsignarTarifa,
    TarifaDetalleTarifario,
  },

  data() {
    return {
      ver_filtros: false,
      disabled: false,
      tarifas: [],
      tarifasFiltradas: [],
      tarifasCargando: false,
      filtroBusqueda: "",
      tipo_vehiculo_filter: {},
      categoria_filter: {},
      producto_liquido_filter: {},
      bloque_filter: {},
      sitio_destino_filter: {},
      filtros: {
        bloque_id: null,
        sitio_destino_id: null,
        tipo_vehiculo_id: null,
        producto_liquido_id: null,
        categoria: null,
      },
      tarifaSeleccionada: null,
      listasForms: {
        bloques: [],
        productos: [],
        categorias: [],
        sitios_destino: [],
        tipos_vehiculos: [],
        tipo_operaciones: [],
      },
    };
  },

  methods: {
    getTiposVehiculos() {
      axios
        .get("api/admin/tiposVehiculos/lista", {
          params: { linea_negocio_id: 2, estado: 1 },
        })
        .then((response) => {
          this.listasForms.tipos_vehiculos = response.data;
        });
    },

    getBloques() {
      axios.get("/api/admin/bloques/lista").then((response) => {
        this.listasForms.bloques = response.data;
      });
    },

    getCategorias() {
      axios.get("/api/lista/72").then((response) => {
        this.listasForms.categorias = response.data;
      });
    },

    getSitios() {
      axios.get("/api/admin/sitios/lista").then((response) => {
        this.listasForms.sitios_destino = response.data;
      });
    },

    getTipoOperacion() {
      axios.get("/api/lista/83").then((response) => {
        this.listasForms.tipo_operaciones = response.data;
      });
    },

    getProductosLiquidos() {
      axios
        .get("api/hidrocarburos/Productos/lista")
        .then((response) => {
          let respuesta = response.data;
          this.listasForms.productos = respuesta;
        })
        .catch((error) => {
          this.$swal({
            icon: "error",
            title: "Ocurrió un error: " + error,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },

    selectTipoVehiculoFilter() {
      this.filtros.tipo_vehiculo_id = null;
      if (this.tipo_vehiculo_filter) {
        this.filtros.tipo_vehiculo_id = this.tipo_vehiculo_filter.id;
      }
      this.cargarTarifas();
    },

    selectCategoriaFilter() {
      this.filtros.categoria = null;
      if (this.categoria_filter) {
        this.filtros.categoria = this.categoria_filter.numeracion;
      }
      this.cargarTarifas();
    },

    selectProductoLiquidoFilter() {
      this.filtros.producto_liquido_id = null;
      if (this.producto_liquido_filter) {
        this.filtros.producto_liquido_id = this.producto_liquido_filter.id;
      }
      this.cargarTarifas();
    },

    selectBloqueFilter() {
      this.filtros.bloque_id = null;
      if (this.bloque_filter) {
        this.filtros.bloque_id = this.bloque_filter.id;
      }
      this.cargarTarifas();
    },

    selectSitioDestinoFilter() {
      this.filtros.sitio_destino_id = null;
      if (this.sitio_destino_filter) {
        this.filtros.sitio_destino_id = this.sitio_destino_filter.id;
      }
      this.cargarTarifas();
    },

    cargarTarifas() {
      this.tarifasCargando = true;
      let params = {
        tarifario_id: this.$parent.form.id,
        bloque_id: this.filtros.bloque_id,
        sitio_destino_id: this.filtros.sitio_destino_id,
        tipo_vehiculo_id: this.filtros.tipo_vehiculo_id,
        categoria: this.filtros.categoria,
        producto_liquido_id: this.filtros.producto_liquido_id,
      };
      axios
        .get("/api/hidrocarburos/tarifarios/showTarifas", {
          params: params,
        })
        .then((response) => {
          this.tarifas = response.data.data || response.data || [];
          this.filtrarTarifas();
          this.tarifasCargando = false;
        })
        .catch((error) => {
          console.error("Error al cargar tarifas:", error);
          this.tarifas = [];
          this.filtrarTarifas();
          this.tarifasCargando = false;
          this.$swal({
            icon: "error",
            title: "Error al cargar tarifas",
            text: "No se pudieron cargar las tarifas del tarifario",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });
        });
    },

    filtrarTarifas() {
      if (!this.filtroBusqueda) {
        this.tarifasFiltradas = [...this.tarifas];
      } else {
        const busqueda = this.filtroBusqueda.toLowerCase();
        this.tarifasFiltradas = this.tarifas.filter((tarifa) => {
          return (
            (tarifa.nombre && tarifa.nombre.toLowerCase().includes(busqueda)) ||
            (tarifa.tipo_vehiculo?.nombre &&
              tarifa.tipo_vehiculo.nombre.toLowerCase().includes(busqueda)) ||
            (tarifa.bloque?.nombre &&
              tarifa.bloque.nombre.toLowerCase().includes(busqueda)) ||
            (tarifa.sitio_destino?.nombre &&
              tarifa.sitio_destino.nombre.toLowerCase().includes(busqueda)) ||
            (tarifa.producto_liquido?.nombre &&
              tarifa.producto_liquido.nombre
                .toLowerCase()
                .includes(busqueda)) ||
            (tarifa.id && tarifa.id.toString().includes(busqueda))
          );
        });
      }
    },

    editarTarifa(tarifa) {
      this.$refs.tarifarioAsignarTarifa.form = { ...tarifa };
      this.$refs.tarifarioAsignarTarifa.bloque = { ...tarifa.bloque };
      this.$refs.tarifarioAsignarTarifa.sitio_destino = {
        ...tarifa.sitio_destino,
      };
      this.$refs.tarifarioAsignarTarifa.tipo_vehiculo = {
        ...tarifa.tipo_vehiculo,
      };
      this.$refs.tarifarioAsignarTarifa.categoria = this.listasForms.categorias.find(
        (categoria) => categoria.numeracion === tarifa.categoria
      );
      this.$refs.tarifarioAsignarTarifa.tipo_operacion = this.listasForms.tipo_operaciones.find(
        (tipo_operacion) => tipo_operacion.numeracion === tarifa.tipo_operacion
      );
      this.$refs.tarifarioAsignarTarifa.producto_liquido = {
        ...tarifa.producto_liquido,
      };
      // Asegurar que se mantengan los IDs del tarifario
      this.$refs.tarifarioAsignarTarifa.form.tarifario_id = this.$parent.form.id;
    },

    verDetallesTarifa(tarifa_id) {
      this.$refs.tarifaDetalleTarifario.getModal(tarifa_id);
    },

    eliminarTarifa(tarifa) {
      this.$swal({
        title: "¿Estás seguro?",
        text: `¿Deseas eliminar la tarifa "${tarifa.nombre || tarifa.id}"?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$parent.cargando = true;
          axios
            .delete(`/api/hidrocarburos/tarifas/${tarifa.id}`)
            .then((response) => {
              this.$parent.cargando = false;
              this.$swal({
                icon: "success",
                title: "Tarifa eliminada",
                text: "La tarifa se eliminó exitosamente",
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              });
              this.cargarTarifas();
            })
            .catch((error) => {
              this.$parent.cargando = false;
              this.$swal({
                icon: "error",
                title: "Error al eliminar",
                text: "No se pudo eliminar la tarifa",
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              });
            });
        }
      });
    },
  },

  beforeMount() {
    this.getBloques();
    this.getCategorias();
    this.getSitios();
    this.getTipoOperacion();
    this.getTiposVehiculos();
    this.getProductosLiquidos();
  },
};
</script>

<style>
.bg-gradient-primary {
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
}

.tarifa-row:hover {
  background-color: #f8f9fa;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
}

/* Asegurar que la tabla ocupe todo el ancho */
.table-responsive {
  width: 100%;
  overflow-x: auto;
}

.table {
  width: 100% !important;
  min-width: 100%;
}

/* Ajustar columnas para mejor distribución del espacio */
.table th,
.table td {
  white-space: nowrap;
  vertical-align: middle;
}

.table th:nth-child(1) {
  width: 8%;
} /* ID */
.table th:nth-child(2) {
  width: 20%;
} /* Nombre */
.table th:nth-child(3) {
  width: 15%;
} /* Tipo Vehículo */
.table th:nth-child(4) {
  width: 15%;
} /* Bloque */
.table th:nth-child(5) {
  width: 8%;
} /* KM */
.table th:nth-child(6) {
  width: 10%;
} /* Categoría */
.table th:nth-child(7) {
  width: 10%;
} /* Tipo Op. */
.table th:nth-child(8) {
  width: 12%;
} /* Producto */
.table th:nth-child(9) {
  width: 12%;
} /* Acciones */

.badge {
  font-size: 0.75em;
  padding: 0.375rem 0.5rem;
}

.btn-group-sm .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}

@media (max-width: 768px) {
  .modal-xl {
    max-width: 95%;
  }

  .table-responsive {
    font-size: 0.875rem;
  }

  .btn-group-sm .btn {
    padding: 0.2rem 0.4rem;
    font-size: 0.75rem;
  }
}

.spinner-border {
  width: 2rem;
  height: 2rem;
}

.fa-spin {
  animation: fa-spin 1s infinite linear;
}

@keyframes fa-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.opacity-75 {
  opacity: 0.75;
}

/* Animaciones suaves */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
